import { Badge } from "@mantine/core";

// Colors mirror the recipient status lifecycle: neutral before send, blue once
// sent, green for positive engagement, red for failures. 'sending' is the
// in-between state — claimed by a background send job, not yet handed to the
// mailer — so it reads as "Queued" to the organizer.
const STATUS_CONFIG = {
  imported: { label: "Imported", color: "gray" },
  sending: { label: "Queued", color: "yellow" },
  sent: { label: "Sent", color: "blue" },
  delivered: { label: "Delivered", color: "cyan" },
  opened: { label: "Opened", color: "teal" },
  bounced: { label: "Bounced", color: "red" },
  registered: { label: "Registered", color: "green" },
};

// Select options for filtering by status, ordered by the lifecycle.
export const INVITE_STATUS_OPTIONS = Object.entries(STATUS_CONFIG).map(
  ([value, { label }]) => ({ value, label })
);

const InviteStatusBadge = ({ status }) => {
  const config = STATUS_CONFIG[status] || { label: status, color: "gray" };
  return (
    <Badge color={config.color} variant="light">
      {config.label}
    </Badge>
  );
};

export default InviteStatusBadge;
